<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
    <rect x="0.399902" width="40" height="40" rx="12" fill="#393E45"/>
    <g clip-path="url(#clip0_8768_89737)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.766 15.3661C16.2542 14.878 17.0456 14.878 17.5338 15.3661L20.3999 18.2322L23.266 15.3661C23.7542 14.878 24.5456 14.878 25.0338 15.3661C25.5219 15.8543 25.5219 16.6457 25.0338 17.1339L22.1677 20L25.0338 22.8661C25.5219 23.3543 25.5219 24.1457 25.0338 24.6339C24.5456 25.122 23.7542 25.122 23.266 24.6339L20.3999 21.7678L17.5338 24.6339C17.0456 25.122 16.2542 25.122 15.766 24.6339C15.2779 24.1457 15.2779 23.3543 15.766 22.8661L18.6321 20L15.766 17.1339C15.2779 16.6457 15.2779 15.8543 15.766 15.3661Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_8768_89737">
    <rect width="24" height="24" fill="white" transform="translate(8.3999 8)"/>
    </clipPath>
    </defs>
  </svg>
</template>

